import { useTranslation } from "@/shared/providers/LanguageProvider";
import { usePageActions } from "@/shared/hooks/usePageActions";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { FormField, inputClass } from "../components/FormField";
import { useEnterpriseCompanyProfile } from "../hooks/useEnterpriseCompanyProfile";

export function EnterpriseCompanyProfilePage() {
  const { t } = useTranslation();
  const labels = t.safecheck.settingsPage.companyProfile;
  const { showToast } = usePageActions();
  const {
    name,
    setName,
    address,
    setAddress,
    phone,
    setPhone,
    loading,
    saving,
    error,
    usingApi,
    save,
  } = useEnterpriseCompanyProfile();

  const handleSave = async () => {
    const ok = await save();
    if (ok) {
      showToast(t.actions.saved);
    }
  };

  const busy = loading || saving;

  return (
    <>
      <Breadcrumbs
        homeHref="/dashboard/enterprise"
        items={[
          { label: t.safecheck.nav.settings },
          { label: labels.pageTitle },
        ]}
      />

      <div className="theme-card p-6">
        <h2 className="mb-6 text-base font-semibold text-foreground">{labels.sectionTitle}</h2>

        {loading && <p className="mb-4 text-sm text-muted">Chargement…</p>}
        {error && <p className="mb-4 text-sm text-danger">{error}</p>}
        {usingApi && !loading && (
          <p className="mb-4 text-xs text-muted">Données synchronisées depuis l&apos;API.</p>
        )}

        <FormField label={labels.fields.companyName}>
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            className={inputClass}
            disabled={busy}
            required
          />
        </FormField>

        <FormField label={labels.fields.address}>
          <input
            value={address}
            onChange={(event) => setAddress(event.target.value)}
            className={inputClass}
            disabled={busy}
            placeholder="Ex: Avenue du Tchad N° 5D, Kinshasa GOMBE"
          />
        </FormField>

        <FormField label={labels.fields.phone}>
          <input
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
            className={inputClass}
            disabled={busy}
            placeholder="+243 XX XXX XXXX"
          />
        </FormField>

        <div className="mt-8">
          <button
            type="button"
            onClick={() => void handleSave()}
            disabled={busy}
            className="rounded-lg bg-primary px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-primary/90 disabled:opacity-60"
          >
            {saving ? "Enregistrement…" : labels.save}
          </button>
        </div>
      </div>
    </>
  );
}
